import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { ITermsAndConditionsFeature } from '.';
import { TermsAndConditionsState } from './terms-and-conditions.state';

export const getTermsAndConditionsState: MemoizedSelector<ITermsAndConditionsFeature, TermsAndConditionsState> = createFeatureSelector<
  TermsAndConditionsState
>(nameof<ITermsAndConditionsFeature>('termsAndConditionsFeature'));

export const getIsLoading = createSelector(getTermsAndConditionsState, (state: TermsAndConditionsState) => state.isLoading);
export const getTermsAndConditionsContent = createSelector(
  getTermsAndConditionsState,
  (state: TermsAndConditionsState) => state.termsAndConditionsContent
);
export const getFAQContent = createSelector(getTermsAndConditionsState, (state: TermsAndConditionsState) => state.faqContent);
export const getPrivacyPolicyContent = createSelector(
  getTermsAndConditionsState,
  (state: TermsAndConditionsState) => state.privacyPolicyContent
);
